export default __webpack_public_path__ + "static/media/navstep2.pic.a1c2c8ec.jpg";